import { useNavigate } from 'react-router-dom';
import { DataGrid } from '@/components/data-grid';
import type { ColumnFilterGroup } from '@/components/data-grid';
import { ROUTES } from '@/app/routes';
import type { PostManagerResponseDTO } from '@/api/generated/model';
import { useContentList } from '../api';
import { contentColumns } from '../columns';
import { ContentInfrastructureHealth } from '../components/ContentInfrastructureHealth';
import { ContentMetricsStrip } from '../components/ContentMetricsStrip';

// Server-side type filter — codes map to backend PostRequestDTO.postTypes[] (N/I/E/S/F/M).
// Live (L) is excluded from Content Management (search query also filters it out).
const TYPE_FILTER: ColumnFilterGroup = {
  columnKey: 'type',
  label: 'Type',
  options: [
    { key: 'N', label: 'Post' },
    { key: 'I', label: 'Images' },
    { key: 'E', label: 'Exclusive' },
    { key: 'S', label: 'Story' },
    { key: 'F', label: 'Flicks' },
    { key: 'M', label: 'Message' },
  ],
};

export function ContentListPage() {
  const navigate = useNavigate();
  const table = useContentList();

  return (
    <div className="flex h-full flex-col gap-4 p-4">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <ContentMetricsStrip />
        <ContentInfrastructureHealth />
      </div>

      <div className="min-h-0 flex-1">
        <DataGrid<PostManagerResponseDTO>
          title="Content Management"
          searchPlaceholder="Search content…"
          columns={contentColumns}
          rows={table.rows}
          total={table.total}
          isLoading={table.isLoading}
          isFetchingNextPage={table.isFetchingNextPage}
          isError={table.isError}
          error={table.error}
          endReached={table.endReached}
          page={table.page}
          totalPage={table.totalPage}
          onPageChange={table.setPage}
          isFetching={table.isFetching}
          onLoadMore={table.fetchNextPage}
          onRetry={() => void table.refetch()}
          search={table.search}
          onSearchChange={table.setSearch}
          filterGroups={[TYPE_FILTER]}
          selectedFilters={table.filters}
          onFiltersChange={table.setFilters}
          getRowId={(r) => String(r.id)}
          onRowClick={(r) => void navigate(ROUTES.contentDetails(String(r.id)))}
          emptyMessage="No content found"
          // Server-side sorts: earnings (earningSortOrder) and time (timeSortOrder, TM-3323 —
          // click Time to switch latest-first / earliest-first). The remaining columns have no
          // sort field on the search DTO, so they stay unclickable.
          onSortChange={table.toggleSort}
          sortableColumns={['earnings', 'time']}
          sortState={table.sort}
        />
      </div>
    </div>
  );
}
